/**
 * The DOM attributes `AnimateNumber` writes and the portals client-error reporter reads back in its
 * hydration counter snapshot. Shared as constants — its own module so the client ENTRY bundle, which
 * builds the snapshot, does not pull the whole component in — because the two sides live in different
 * packages and a rename tied only by convention would silently blank the snapshot.
 */
export const COUNTER_VALUE_ATTR = 'data-value';
export const COUNTER_MODE_ATTR = 'data-counter-mode';
// The locale the render that produced the node formatted with. React does not patch attributes on
// hydration, so after a mismatch the DOM keeps the SERVER's value on hydrated nodes and the CLIENT's
// on client-rendered ones — which is exactly what lets the snapshot name the side that formatted
// with the wrong locale (the open question in the TEC-3696 family of #418 tickets).
export const COUNTER_LOCALE_ATTR = 'data-counter-locale';
